import type { VoteType } from '@/constants/schema-constants'

export class Vote {
  subjectId!: string
  voteType!: VoteType
}
